import React from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
  classes?: {
    parantClass?: string;
    textClass?: string;
  };
}

const LimitedTimeBadge: React.FC<Props> = ({ classes }) => {
  return (
    <div
      className={twMerge(
        `bg-success-950 rounded-full  px-2.5 py-[5px] `,
        classes?.parantClass,
      )}
    >
      <p
        className={twMerge(
          `2xl:text-sm xl:text-sm lg:text-sm  md:text-[10px] 2xl:font-semibold xl:font-semibold lg:font-semibold  md:font-medium leading-[22px] text-success-400 line-clamp-1`,
          classes?.textClass,
        )}
      >
        Limited Time Deal
      </p>
    </div>
  );
};

export default LimitedTimeBadge;
